import { useMemo } from 'react';
import { currentUser } from 'js/utils/user';
import { FollowableUser } from 'js/social/shared/types';

export const useCurrentUserAsFollowableUser = (): FollowableUser | null =>
  useMemo(
    () =>
      currentUser
        ? {
            id: currentUser.id,
            firstName: currentUser.first_name,
            middleInitials: currentUser.middle_initials || null,
            lastName: currentUser.last_name,
            pageName: currentUser.page_name,
            domainName: currentUser.domain_name,
            url: currentUser.url,
            createdAt: currentUser.created_at || '',
            displayName: currentUser.display_name || '',
            photo: currentUser.photo || '',
            following: false,
            university: currentUser.department?.university
              ? {
                  id: currentUser.department.university.id,
                  displayName: currentUser.department.university.name,
                  url: currentUser.department.university.name,
                }
              : null,
            followers: 0,
          }
        : null,
    [],
  );
